import { Injectable } from "@angular/core";
import { RestService } from "../../core/rest.service";
import { AttachmentUploadParameter, AttachmentFile, AttachmentDeleteParameter, AttachmentInfo } from "./attachments.model";
import { Http } from '@angular/http';

@Injectable({
    providedIn: 'root'
})
export class AttachmentRest {
    constructor(private http: RestService, private httpClient: Http) { }

    public addAttachmentAndGetMetadata(parameter: AttachmentUploadParameter) {
        return this.http.post(`api/${parameter.controller}/attachments/add`, parameter);
    }

    public get(attachmentId: number, controller: string) {
        return this.http.get<AttachmentFile>(`api/${controller}/attachments/get/${attachmentId}`);
    }

    public getFiles(objectTypeId: number, objectId: number, controller: string) {
        return this.http.get<AttachmentFile[]>(`api/${controller}/attachments/get/${objectTypeId}/${objectId}`);
    }

    public getAttachmentsGrid(path: string) {
        return this.http.get<AttachmentInfo[]>(path);
    }

    public delete(parameter: AttachmentDeleteParameter) {
        return this.http.post<AttachmentFile>('api/' + parameter.controller + '/attachments/delete', { attachmentId: parameter.attachmentId });
    }
    
    public checkFileNames(controller: string, filename: string, objectTypeId: number, objectId: number) {
        return this.http.get<boolean>(`api/${controller}/checkfilenames/${filename}/${objectTypeId}/${objectId}`);
    }
}